module.exports = __webpack_public_path__ + "media/images/icon__matchdayNavigation--pagination--arrow@3x-32e659c81f27dfcb310f92d80880c09f.png";